"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
var utils_1 = require("../../utils/utils");
/**
 * Debounce the passed function. This means that the function will only fire once while
 * it is being called within the threshold.
 * @param fn The function to be debounced
 * @param threshold How long to wait before allowing the function to be triggered again. Default is `100`.
 * @param immediate Whether to trigger the function at the start instead of after the threshold. Default is `false`.
 * @return A version of this function that will only trigger when it isn't called for the threshold amount of time.
 */
// tslint:disable-next-line: no-any
exports.debounce = utils_1.makeSsrSafe(function (fn, threshold, immediate) {
    if (threshold === void 0) { threshold = 100; }
    if (immediate === void 0) { immediate = false; }
    var timeout;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var call = function () {
            timeout = undefined;
            if (!immediate) {
                return fn.apply(_this, args);
            }
        };
        if (immediate && !timeout) {
            call();
        }
        clearTimeout(timeout);
        timeout = window.setTimeout(call, threshold);
    };
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Functions/Debounce.js
// module id = 668
// module chunks = 8